import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { PowerComponent } from '../components/power/power.component';
import { OilGasComponent } from '../components/oil-gas/oil-gas.component';
import { WaterDiposalComponent } from '../components/water-diposal/water-diposal.component';
import { FEComponent } from '../components/fe/fe.component';
import { FecapacitiesComponent } from '../components/fecapacities/fecapacities.component';
import { FeFlowNetworkComponent } from '../components/flow-network/flow-network.component';
import { ScenarioComponent } from '../components/scenario/scenario.component';
import { LoginComponent } from '../components/login/login.component';
import { AdminComponent } from '../components/admin/admin.component';
import { ActiveStandardsComponent } from '../components/active-standards/active-standards.component';
import { WaterStandardsComponent } from '../components/water-standards/water-standards.component';
import { CdpComponent } from '../components/cdp/cdp.component';
import { OilGasTabComponent } from '../components/oil-gas-tab/oil-gas-tab.component';
import { FeCorridorSystemsComponent } from '../components/fe-corridor-systems/fe-corridor-systems.component';
import { GasPlantMappingComponent } from '../components/gas-plant-mapping/gas-plant-mapping.component';
import { GasPlantCapacitiesComponent } from '../components/gas-plant-capacities/gas-plant-capacities.component';
import { AlternateCapacityComponent } from '../components/alternate-capacity/alternate-capacity.component';
import { CdpCorridorMappingComponent } from '../components/cdp-corridor-mapping/cdp-corridor-mapping.component';
import { WaterAdminViewComponent } from '../components/water-admin-view/water-admin-view.component';
import { WaterMappingViewComponent } from '../components/water-mapping-view/water-mapping-view.component';
import { AlternateWaterCapacityComponent } from '../components/alternate-water-capacity/alternate-water-capacity.component';
import { WaterCapacitiesViewComponent } from '../components/water-capacities-view/water-capacities-view.component';
import { WaterSubDevArea } from '../components/water-sub-dev-area/water-sub-dev-area';
import { HomeDashboardComponent } from '../components/home-dashboard/home-dashboard.component';
import { EmbeddedReportComponent } from '../components/embedded-report/embedded-report.component';

const routes: Routes = [
  { path: 'login', title: 'Login', component: LoginComponent },
  { path: 'home', title: 'CMP Applications', component: HomeDashboardComponent, canActivate: [MsalGuard] },
  {
    path: 'aggregator',
    title: 'Aggregator',
    component: EmbeddedReportComponent,
    canActivate: [MsalGuard],
    data: {
      reportTitle: 'CMP Aggregator',
      reportUrl: 'https://app.powerbi.com/reportEmbed?reportId=a8a8b530-fdfd-4b59-9da7-1219ff710390&autoAuth=true&ctid=fd799da1-bfc1-4234-a91c-72b3a1cb9e26',
    },
  },
  {
    path: 'outlook',
    title: 'Outlook',
    component: EmbeddedReportComponent,
    canActivate: [MsalGuard],
    data: {
      reportTitle: 'CMP Outlook',
      reportUrl: 'https://app.powerbi.com/reportEmbed?reportId=0965f95a-5411-4ae6-88d1-04bd467e7390&autoAuth=true&ctid=fd799da1-bfc1-4234-a91c-72b3a1cb9e26',
    },
  },
  { path: 'power', title: 'Power', component: PowerComponent, canActivate: [MsalGuard] },
  {
    path: 'oil-gas-tab',
    component: OilGasTabComponent,
    canActivate: [MsalGuard],
    children: [
      { path: '', redirectTo: 'oil-gas', pathMatch: 'full' },
      { path: 'oil-gas', title: 'Oil & Gas', component: OilGasComponent, canActivate: [MsalGuard] },
      { path: 'cdp-flow-network', title: 'CDP Flow Network', component: CdpComponent, canActivate: [MsalGuard] },
      { path: 'cdp-corridor-mapping', title: 'CDP Corridor Mapping', component: CdpCorridorMappingComponent, canActivate: [MsalGuard] },
      { path: 'gas-plant-mapping', title: 'Gas Plant Mapping', component: GasPlantMappingComponent, canActivate: [MsalGuard] },
      { path: 'gas-plant-capacities', title: 'Gas Plant Capacities', component: GasPlantCapacitiesComponent, canActivate: [MsalGuard] },
      { path: 'alternate-capacity', title: 'Alternate Capacity', component: AlternateCapacityComponent, canActivate: [MsalGuard] }
    ]
  },
  {
    path: 'fe',
    component: FEComponent,
    canActivate: [MsalGuard],
    children: [
      { path: 'capacities', title: 'Fe Capacities', component: FecapacitiesComponent, canActivate: [MsalGuard] },
      { path: 'flow-network', title: 'FE Flow Network', component: FeFlowNetworkComponent, canActivate: [MsalGuard] },
      { path: 'scenario-modelling', title: 'Scenario Modelling', component: ScenarioComponent, canActivate: [MsalGuard] },
      { path: 'corridor-systems', title: 'FE Corridor Systems', component: FeCorridorSystemsComponent, canActivate: [MsalGuard] },
      { path: 'admin', title: 'Admin', component: AdminComponent, canActivate: [MsalGuard] }
    ]
  },
  {
    path: 'water-disposal',
    component: WaterDiposalComponent,
    canActivate: [MsalGuard],
    children: [
      { path: '', redirectTo: 'active-standards', pathMatch: 'full' },
      { path: 'active-standards', title: 'Active Standards', component: ActiveStandardsComponent, canActivate: [MsalGuard] },
      { path: 'water-standards', title: 'Water Standards', component: WaterStandardsComponent, canActivate: [MsalGuard] },
      { path: 'water-capacities-view', title: 'Water Capacity View', component: WaterCapacitiesViewComponent, canActivate: [MsalGuard] },
      { path: 'water-admin-view', title: 'Water Admin View', component: WaterAdminViewComponent, canActivate: [MsalGuard] },
      { path: 'water-flow-network', title: 'Water Flow Network', component: WaterMappingViewComponent, canActivate: [MsalGuard] },
      { path: 'water-sub-dev-area', title: 'Water Sub Dev Area', component: WaterSubDevArea, canActivate: [MsalGuard] },
      { path: 'alternate-water-capacity', title: 'Alternate Water Capacity', component: AlternateWaterCapacityComponent, canActivate: [MsalGuard] }
    ]
  },
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  // { path: '**', redirectTo: '/fe' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
